import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "mr-32" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "mr-36" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "mt-5 sm:mt-6 text-center" }

import { computed, inject, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyPointRequestApprovalDialog',
  props: { show: Boolean, form: Object },
  emits: [
  "submit",
  "update:show",
  "update:form",
  "edited",
  "closed",
],
  setup(__props, { emit }) {

const props = __props

const store = useStore();
const SelectorIcon = require("@heroicons/vue/solid/SelectorIcon");


const axios = inject("$axios") as AxiosInstance;
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const preview = ref(props.form?.imageUrl);

const file = ref();

const reject = async () => {
  const payload = {
    id: props.form?.id,
    rejectBy: store.state.user.username,
  };

  await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/adjust-point/reject`,
    payload
  );
  emit("edited");
  showSync.value = false;
};

const approve = async () => {
  const payload = {
    id: props.form?.id,
    approveBy: store.state.user.username,
  };

  await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/adjust-point/approve`,
    payload
  );
  emit("edited");
  showSync.value = false;
};

const onClose = () => {
  // preview.value = null;
  emit("closed");
  showSync.value = false;
};

watch(showSync, (val) => {
  if (val) {
    preview.value = (props.form as any).imageUrl;
  }
});
// watch((props.form as any).imageUrl,(val) => {
//   preview.value = val
// },{deep:true})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.pointRequest.loyaltyPointRequest")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.pointRequest.username")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              readonly: "",
                              class: "rounded",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (((__props.form as any).username) = $event)),
                              placeholder: _ctx.$t('messages.pointRequest.username')
                            }, null, 8, _hoisted_7), [
                              [_vModelText, (__props.form as any).username]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.pointRequest.amount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              readonly: "",
                              class: "rounded",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((__props.form as any).amount) = $event)),
                              placeholder: _ctx.$t('messages.pointRequest.amount')
                            }, null, 8, _hoisted_9), [
                              [_vModelText, (__props.form as any).amount]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.pointRequest.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-red-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (reject()))
                      }, _toDisplayString(_ctx.$t("messages.pointRequest.reject")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (approve()))
                      }, _toDisplayString(_ctx.$t("messages.pointRequest.approve")), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})